import React from 'react'
import { BrowserRouter } from 'react-router-dom'
//import { useQuery } from 'react-apollo-hooks'

import Routes from './routes'
import './i18n'

import {
	AppProvider,
	//CheckCredentialsQuery,
	//useStoreValue,
	//AppActionTypes,
} from './store'

const App: React.FC = () => {
	//const { data, loading } = useQuery(CheckCredentialsQuery)
	//const [{ user }, storeDispatch] = useStoreValue()

	// useEffect(() => {
	// 	if (!loading) {
	// 		if (data && data.checkCredentials) {
	// 			storeDispatch({
	// 				type: AppActionTypes.UpdateUser,
	// 				user: data.checkCredentials,
	// 			})
	// 		} else {
	// 			if (user) {
	// 				storeDispatch({
	// 					type: AppActionTypes.ResetUser,
	// 				})
	// 			}
	// 		}
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [loading])

	return (
		<BrowserRouter>
			<main className="main-wrapper">
				<Routes />
			</main>
		</BrowserRouter>
	);
}

export default () => (
	<AppProvider>
		<App />
	</AppProvider>
)
